/**
 * PM web admin tile API client (D-121, D-128).
 *
 * Reads aggregated worker state for the Queue health + Clock skew dashboards.
 * Both endpoints are require_pm-gated server-side (queue_health_router.py +
 * clock_skew_router.py); the cookie-bound pm_session travels via the apiGet
 * `credentials: 'include'` discipline.
 */
import { apiGet } from "./client";

export interface QueueHealthRow {
  worker_id: number;
  worker_name: string;
  queue_depth_inspections: number;
  queue_depth_photos: number;
  queue_bytes_photos: number;
  free_disk_bytes: number;
  last_sync_attempt_at: string | null;
  last_sync_success_at: string | null;
  app_version: string | null;
  battery_pct: number | null;
  cellular_signal_dbm: number | null;
  recorded_at_server: string;
}

export interface ClockSkewRow {
  id: number;
  worker_id: number;
  worker_name: string;
  delta_seconds: number;
  raw_client_value_iso: string;
  server_received_at: string;
}

export const fetchQueueHealth = (): Promise<QueueHealthRow[]> =>
  apiGet<QueueHealthRow[]>("/api/admin/workers/queue-health");

export const fetchClockSkewAudit = (days = 7): Promise<ClockSkewRow[]> =>
  apiGet<ClockSkewRow[]>(`/api/admin/clock-skew?days=${days}`);

/**
 * Phase 7 Plan 03 / D-164 — PM admin Outdated APK row.
 *
 * Row shape mirrors the server's outdated_apk_router response (Plan 02
 * server/app/admin/outdated_apk_router.py + outdated_apk_repository.py).
 * `color` is SERVER-COMPUTED via compute_color() (T-7-03-02 mitigation —
 * client renders precomputed verdict, never calls semver locally). app_version
 * VARCHAR(32) was added in Phase 5 Plan 01; nullable when worker has never
 * pinged since the column was added.
 */
export interface OutdatedApkRow {
  worker_id: number;
  worker_name: string;
  app_version: string | null;
  last_sync_success_at: string | null;
  color: "green" | "yellow" | "red" | "grey";
}

export const fetchOutdatedApk = (): Promise<OutdatedApkRow[]> =>
  apiGet<OutdatedApkRow[]>("/api/admin/workers/outdated-apk");
